import { Component, inject } from '@angular/core';
import { ListViewProviderDirective } from '@ntap/core';
import { tap } from 'rxjs';

@Component({
  selector: `app-odabir-stranke`,
  templateUrl: './odabir-stranke.component.html'
})
export class OdabirStrankeComponent {
  public showDialog = false;

  private listviewProvider = inject(ListViewProviderDirective);

  private addSubjektActionName = 'seup.AddSubjekti';

  public refresh() {
    this.listviewProvider.refresh();
  }

  public onSelectedItem(stranke: any[]) {
    const actionParams = {
      $selected: stranke,
      $parent: this.listviewProvider.viewState
    };

    this.listviewProvider
      .executeAction(this.addSubjektActionName, actionParams)
      .pipe(
        tap(() => {
          this.refresh();
        })
      )
      .subscribe();

    this.showDialog = false;
  }
}
